import React, {FC} from 'react'
import {useSelector} from 'react-redux'

import ReactJson from 'react-json-view'

import {
  select_databaseDetails,
  select_databaseIdToCopy,
  select_error,
  select_statusDetails,
} from 'redux/databases/selectors'
import {useAppDispatch} from 'redux/config'
import {
  Button,
  ErrorState,
  Icon,
  Spinner,
  Stack,
  Typography,
} from '@mdsol/onex-design'
import {databasesAC, fetchDatabaseDetails} from 'redux/databases/databases.duck'
import FeatureFlagsControls from 'components/view/databases/FeatureFlagsControls'
import {Status} from 'commonTypes'
import CustomConfigOverridesControls from './CustomConfigOverridesControls'

const DatabaseDetailsPanel: FC = () => {
  const dispatch = useAppDispatch()

  const database = useSelector(select_databaseDetails)
  const status = useSelector(select_statusDetails)
  const error = useSelector(select_error)
  const databaseIdDetails = useSelector(select_databaseIdToCopy)

  const handleClose = () => {
    dispatch(databasesAC.hideDatabaseDetails())
    dispatch(databasesAC.databaseIdToCopyApplied(''))
  }

  const handleRefreshDetails = () => {
    dispatch(fetchDatabaseDetails(databaseIdDetails))
  }

  return (
    <div className='row-details-panel' role='database-details-container'>
      <div className='header onex-data-grid-control'>
        <Typography variant='h4'>
          Database Details
        </Typography>

        <Button dataTestId='close-details-icon' onClick={handleClose} variant='secondary' buttonStyle='ghost' buttonType='icon'>
          <Icon>close</Icon>
        </Button>
      </div>
      <div className='body onex-data-grid-control scroll-details'>
        <Stack>
          {/*wrapped so when expanded the spacing is preserved*/}
          <div>
            <FeatureFlagsControls />
          </div>
          <div>
            <CustomConfigOverridesControls />
          </div>

          <div className={`body onex-data-grid-control ${status === Status.PENDING ? 'with-spinner' : ''}`}>
            {status === Status.PENDING && <Spinner dataTestId='database-details-spinner' size='lg' />}
            {database && status === Status.OK && (
              <ReactJson
                src={database}
                theme='rjv-default'
                iconStyle='circle'
                indentWidth={2}
                collapseStringsAfterLength={16}
                quotesOnKeys={false}
              />
            )
            }
            {status === Status.REJECTED && (
              <ErrorState
                buttonTitle='Try again'
                className='error-state-component-details'
                dataTestId='details-error-state'
                description={error?.message ?? 'Error occurred while loading database details.'}
                onClick={handleRefreshDetails}
                title='Server Error'
                defaultImgVariant='browser'
                variant='section'
                errorId={databaseIdDetails}
              />)
            }
          </div>
        </Stack>
      </div>
      <div className='footer onex-data-grid-control'>
        <Stack direction='horizontal' gap={2}>
          <Button dataTestId='close-details-button' onClick={handleClose} size='md' variant='secondary'>
            Close
          </Button>
        </Stack>
      </div>
    </div>
  )
}

export default DatabaseDetailsPanel
